<ng-template sbdlResourceHost></ng-template>